exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-component[data-v-4097faed]{padding-top:20px}.background-component .form-content .el-form-item[data-v-4097faed]{margin-bottom:20px}.background-component .action-buttons[data-v-4097faed]{margin-top:30px;text-align:center}.background-component .action-buttons .el-button[data-v-4097faed]{margin:0 10px;padding:10px 30px}", ""]);

// exports
